import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationLinks = () => {
  const registrationTypes = [
    { id: 1, icon: 'Building2', title: 'Opdrachtgever', description: 'Plaats opdrachten en vind gekwalificeerde professionals', link: '/opdracht-plaatsen' },
    { id: 2, icon: 'Wrench', title: 'Opdrachtnemer', description: 'Vind opdrachten en bouw uw bedrijf uit', link: '/opdracht-zoeken' },
    { id: 3, icon: 'Users', title: 'Partner', description: 'Verdien commissie door opdrachten en professionals te brengen', link: '/wordt-partner' }
  ];

  return (
    <div className="space-y-4">
      <p className="text-xs font-body text-center" style={{ color: '#555555' }}>Nog geen account? Registreer als:</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {registrationTypes?.map((type) => (
          <Link
            key={type?.id}
            to={type?.link}
            className="group p-4 flex flex-col items-center text-center transition-all duration-200"
            style={{ border: '1px solid #1A1A1A' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#2A2A2A'}
            onMouseLeave={e => e.currentTarget.style.borderColor = '#1A1A1A'}
          >
            <div className="w-9 h-9 rounded flex items-center justify-center mb-3 transition-all duration-200" style={{ background: 'rgba(0,229,160,0.08)' }}>
              <Icon name={type?.icon} size={18} color="#00E5A0" />
            </div>
            <h4 className="text-xs font-body font-semibold text-white mb-1">{type?.title}</h4>
            <p className="text-xs" style={{ color: '#555555' }}>{type?.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RegistrationLinks;